module.exports = __webpack_public_path__ + "static/img/Q.45c32c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/Q.png
// module id = JSKm
// module chunks = 0